import { TrixForm } from 'controls/forms/trix_form'
import React from 'react'
import { useDispatch } from 'react-redux'
import { updateChat } from 'reduxes/slices/chats/actions'
import { updateNote } from 'reduxes/slices/notes/actions'

import { css } from 'design'
import { cn } from 'util/cn'

import { useAxios } from '../../../hooks/use_axios'
import { setSelectedTimelineId } from '../../../reduxes/slices/selected/actions'
import { TimelineType } from '../../../types/models'

export type EditTimelineFormProps = {
  item: any
  timeline: TimelineType
}

export const EditTimelineForm = ({ item, timeline }: EditTimelineFormProps) => {
  const dispatch = useDispatch()
  const axios = useAxios()

  const id = `${timeline.tl_type}-${timeline.tl_id}`

  const onSubmit = (html: any) => {
    let promise: any
    switch (timeline.tl_type) {
      case 'Chat':
        promise = dispatch(axios(updateChat(item, { html })))
        break
      case 'Note':
        promise = dispatch(axios(updateNote(item, { html })))
        break
    }

    return promise.then(() => {
      stopEditing()
    })
  }

  const stopEditing = () => {
    dispatch(setSelectedTimelineId(null))
  }

  return (
    <div className={cn('content', editTimelineStyles())}>
      <TrixForm
        id={id}
        trixHtml={item.trix_html}
        onSubmit={onSubmit}
        onCancel={stopEditing}
        placeholder="Edit Message"
        variant="split"
        isEditing
      />
    </div>
  )
}

const editTimelineStyles = css({
  width: '100%',
  padding: '0 !important',

  form: {
    maxHeight: 'initial !important',
  },

  '@md': {
    width: '90%',
    padding: '0 !important',
    backgroundColor: '$grey50',
    border: '1px solid $grey100',
  },
})
